import api from '../utils/api';

class LangsApi {
  getAlLanguages = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/langs', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  createLanguage = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/langs', data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };
}

const langsApi = new LangsApi();
export default langsApi;
